import get from 'lodash/get';

export const mapPrismicProp = (prop, mapAdditionalProps = () => ({})) => {
  const type =
    get(prop, '_type') ||
    get(prop, 'sliceType') ||
    get(prop, 'main.documentType');

  if (type) {
    const { body, primary = {}, ...props } = prop;

    // NB This may result in unnecessary props being passed to components.
    // Might be better to move to final "props" return value
    let optionalProps = {
      ...mapAdditionalProps(prop, type)
    };

    if (body) {
      optionalProps.children = body;
    }

    return {
      type,
      props: {
        ...props,
        ...optionalProps,
        ...primary
      }
    };
  }

  return prop;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/ReactFromPrismic/helpers.js